import { z } from 'zod';

/**
 * Structured daily briefing. Replaces the prose paragraph with scannable slots.
 * AI generation returns this shape directly (we ask Claude for JSON).
 */
export const BriefingSchema = z.object({
  decisions: z.array(z.string()).default([]),
  risks: z.array(z.string()).default([]),
  shipped: z.array(z.string()).default([]),
  meetings: z.array(z.string()).default([]),
  generatedAt: z.string().datetime().nullable(),
  source: z.enum(['ai', 'manual']).nullable(),
});

export type Briefing = z.infer<typeof BriefingSchema>;
